import * as React from 'react';

import { DataGridColumn } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';
import { WorkOrderOutputItemRecord } from '../../../types/workOrder';

export const useWorkOrderOutputItemsColumns =
  (): DataGridColumn<WorkOrderOutputItemRecord>[] => {
    const t = useTranslations();

    return React.useMemo(
      () => [
        {
          key: 'item',
          header: t.workOrderDetailView.outputItems.table.columns.item,
          cell: ({ row }) => <span>{row.itemName || row.itemId}</span>,
          width: 200,
        },
        {
          key: 'targetLot',
          header: t.workOrderDetailView.outputItems.table.columns.targetLot,
          cell: ({ row }) => <span>{row.targetLotNumber || '—'}</span>,
          width: 150,
        },
        {
          key: 'targetTag',
          header: t.workOrderDetailView.outputItems.table.columns.targetTag,
          cell: ({ row }) => <span>{row.targetTagNumber || '—'}</span>,
          width: 150,
        },
        {
          key: 'expectedQty',
          header:
            t.workOrderDetailView.outputItems.table.columns.expectedQuantity,
          cell: ({ row }) => (
            <span>
              {row.expectedQuantityValue.toLocaleString()}{' '}
              {row.expectedQuantityUnit}
            </span>
          ),
          width: 150,
        },
        {
          key: 'actualQty',
          header:
            t.workOrderDetailView.outputItems.table.columns.actualQuantity,
          cell: ({ row }) => (
            <span>
              {row.actualQuantityValue
                ? `${row.actualQuantityValue.toLocaleString()} ${row.actualQuantityUnit}`
                : '—'}
            </span>
          ),
          width: 150,
        },
        {
          key: 'yield',
          header:
            t.workOrderDetailView.outputItems.table.columns.yieldPercentage,
          cell: ({ row }) => (
            <span>
              {row.yieldPercentage ? `${row.yieldPercentage.toFixed(1)}%` : '—'}
            </span>
          ),
          width: 100,
        },
        {
          key: 'notes',
          header: t.workOrderDetailView.outputItems.table.columns.notes,
          cell: ({ row }) => (
            <span className="text-neutral/60">{row.notes || '—'}</span>
          ),
          width: 200,
        },
      ],
      [t],
    );
  };
